module.exports = __webpack_public_path__ + "img/ectivemsp80.0d8a10d4.png";